import type { ReportBoard, ReportBoardsResponse } from "@gettactic/api";
import { REPORT_BOARDS_QUERY_KEY } from "@gettactic/hooks";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api/api";

/**
 * Default boards first, then the caller's own and organization-wide boards,
 * plus whether the caller may publish (from current roles, not the token).
 */
export const useReportBoards = () =>
  useQuery<ReportBoardsResponse>({
    queryKey: [REPORT_BOARDS_QUERY_KEY],
    queryFn: async () => {
      const { result } = await api.client.reporting.listBoards();
      if (!result) {
        throw new Error("empty report boards response");
      }
      return result;
    },
    staleTime: 60 * 1000
  });

/** The key a board is addressed by in the UI: its id, or the default key. */
export const boardKey = (board: ReportBoard): string =>
  board.id ?? `default:${board.default_key ?? ""}`;
